// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_container__njogI {
  display: flex;
  justify-content: space-between;
  /* box-shadow: 2px 2px 8px #a9a3a3a6; */
  width: 100% !important;
  padding: 5px 10px;
  background: linear-gradient(
    94.06deg,
    #879eff -20.72%,
    #e9e2ff 15.45%,
    #cfe5ec 99.94%
  );
  /* height: 35px; */
  position: fixed;
  box-sizing: border-box;
  z-index: 1000;
}

.Header_containerExpanded__8IBR0 {
  align-items: center;
  height: 64px;
  padding: 0 24px;
  background: #ffffff;
  border-bottom: 1px solid #e8eef5;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08);
}

/* ── Second header: UAE/KSA only, sits below the first gradient header ── */
.Header_secondHeader__w30-x {
  position: fixed;
  top: 44px; /* sits immediately below first header */
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  /* z-index: 999; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  padding: 6px 16px;
  background: #ffffff;
  border-bottom: 1px solid #e8eef5;
  /* border-left: 1px solid #e8eef5; */
  /* box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06); */

}

.Header_secondHeaderLeft__5jSyd {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1;
  gap: 0;
}

.Header_secondHeaderRight__hXAWw {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 12px;
}

/* Standalone header for UAE MT / KSA MT — does NOT inherit .container */
.Header_expandedContainer__EWRsS {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 24px;
  background: #ffffff;
  border-bottom: 1px solid #e8eef5;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08);
}

.Header_expandedLeft__-6D-N {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.Header_expandedRight__WisRk {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.Header_menuButton__dRqbh,
.Header_workspaceBadge__4YtBz,
.Header_logoutButton__zD0wR {
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.Header_menuButton__dRqbh {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: linear-gradient(180deg, #0f63b2 0%, #0a4f96 100%);
  box-shadow: 0 10px 24px rgba(0, 92, 188, 0.22);
}

.Header_menuButton__dRqbh svg {
  fill: #ffffff;
}

.Header_workspaceBadge__4YtBz {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: linear-gradient(180deg, #0f63b2 0%, #0a4f96 100%);
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px;
  box-shadow: 0 8px 18px rgba(0, 92, 188, 0.18);
  flex-shrink: 0;
}

.Header_workspaceDot__kvvCZ {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffffff;
  display: block;
}

.Header_titleBlock__BloBy {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.Header_titleExpanded__\\+LWsc {
  font-size: 20px;
  line-height: 1.2;
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Header_subtitle__FApuL {
  font-size: 12px;
  line-height: 1.2;
  font-weight: 500;
  color: #6b7280;
  margin-top: 2px;
}

.Header_headerMenuPanel__UARLn {
  top: 82px;
  left: 28px;
  width: 180px;
  z-index: 1100;
}

.Header_logoutButton__zD0wR {
  width: 38px;
  height: 38px;
  min-width: unset !important;
  border-radius: 50% !important;
  padding: 0 !important;
  background: #f4f7fb !important;
  border: 1.5px solid #dbe4f0 !important;
  box-shadow: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0;
}

.Header_title__-5zqw {
  font-size: 18px;
  text-align: center;
  font-weight: 700;
  color: #272727;
}

.Header_returnHomeBtn__SZmka {
  height: 28px !important;
  border-radius: 4px !important;
  border: 1px solid #d8e1ee !important;
  background: #f8fbff !important;
  color: #5a6f85 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  padding: 2px 12px !important;
  line-height: 1 !important;
  box-shadow: none !important;
}

.Header_returnHomeBtn__SZmka:hover {
  background: #eef5ff !important;
  border-color: #c6d5ea !important;
}

.Header_peplogo__NMKpU {
  float: left;
}

.Header_profile__7A7Jo {
  float: right;
  float: right;
  position: absolute;
  right: 15px;
  top: 21px;
}

/* Sidebar.css */
.Header_sidebar__iiADr {
  width: 50px;
  height: 100vh;
  background-color: rgb(242, 241, 241);
  color: #111;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-top: 20px; */
  transition: width 0.3s;
  z-index: 500;
  position: fixed;
  top: 50px;
  box-shadow: var(--Elevation-X-Elevation-04, 4px)
    var(--Elevation-Y-Elevation-04, 0px)
    var(--Elevation-Blur-Elevation-04, 24px)
    var(--Elevation-Spread-Elevation-04, -2px)
    var(--Elevation-Colors-Elevation-04, rgba(0, 92, 188, 0.08));
}

.Header_sidebar__iiADr.Header_expanded__5YrhI {
  width: 150px;
}

.Header_sidebarItem__YkKhK {
  width: inherit;
  padding: 10px 0px 10px 0px;
  cursor: pointer;
  display: flex;
}

.Header_sidebarItem__YkKhK span {
  padding-left: 15px;
  display: flex;
  align-items: center;
}

.Header_sidebarItem__YkKhK:hover {
  background-color: #444343;
}

.Header_sidebarItemActive__RNxn5 {
  border-left: 8px solid #005cbc;
  margin-right: 5px;
}

@media screen and (max-width: 500px) {
  /* .container{
        padding: 15px 20px;
        height: 60px
    } */

  .Header_sidebar__iiADr {
    top: 0;
    left: 0;
  }

  .Header_title__-5zqw {
    display: none;
  }

  .Header_peplogo__NMKpU {
    display: none;
  }
  .Header_peplogoMobile__5vqGE {
    margin-left: 0.5rem;
  }

  .Header_pepSidebarMobile__Xl4M6 {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }

  .Header_secondHeader__w30-x {
    left: 0;
    right: 0;
    width: 100%;
  }
}

@media screen and (max-width: 900px) {
  .Header_containerExpanded__8IBR0 {
    padding: 0 16px 0 16px;
    height: 72px;
  }

  .Header_titleExpanded__\\+LWsc {
    font-size: 18px;
  }

  .Header_subtitle__FApuL {
    font-size: 11px;
  }

  .Header_headerMenuPanel__UARLn {
    left: 16px;
    top: 64px;
  }
}

@media screen and (min-width: 500px) {
  .Header_peplogoMobile__5vqGE {
    display: none;
  }

  .Header_pepSidebarMobile__Xl4M6 {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Common/Components/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,uCAAuC;EACvC,sBAAsB;EACtB,iBAAiB;EACjB;;;;;GAKC;EACD,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,SAAS,EAAE,wCAAwC;EACnD,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,oCAAoC;EACpC,kDAAkD;;AAEpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA,wEAAwE;AACxE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;EAC9B,sCAAsC;EACtC,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT;;;;gEAI8D;AAChE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE;;;OAGK;;EAEL;IACE,MAAM;IACN,OAAO;EACT;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  /* box-shadow: 2px 2px 8px #a9a3a3a6; */\n  width: 100% !important;\n  padding: 5px 10px;\n  background: linear-gradient(\n    94.06deg,\n    #879eff -20.72%,\n    #e9e2ff 15.45%,\n    #cfe5ec 99.94%\n  );\n  /* height: 35px; */\n  position: fixed;\n  box-sizing: border-box;\n  z-index: 1000;\n}\n\n.containerExpanded {\n  align-items: center;\n  height: 64px;\n  padding: 0 24px;\n  background: #ffffff;\n  border-bottom: 1px solid #e8eef5;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08);\n}\n\n/* ── Second header: UAE/KSA only, sits below the first gradient header ── */\n.secondHeader {\n  position: fixed;\n  top: 44px; /* sits immediately below first header */\n  left: 0;\n  right: 0;\n  width: 100%;\n  box-sizing: border-box;\n  /* z-index: 999; */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 52px;\n  padding: 6px 16px;\n  background: #ffffff;\n  border-bottom: 1px solid #e8eef5;\n  /* border-left: 1px solid #e8eef5; */\n  /* box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06); */\n\n}\n\n.secondHeaderLeft {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  flex: 1;\n  gap: 0;\n}\n\n.secondHeaderRight {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  margin-left: 12px;\n}\n\n/* Standalone header for UAE MT / KSA MT — does NOT inherit .container */\n.expandedContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 64px;\n  padding: 0 24px;\n  background: #ffffff;\n  border-bottom: 1px solid #e8eef5;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08);\n}\n\n.expandedLeft {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.expandedRight {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.menuButton,\n.workspaceBadge,\n.logoutButton {\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.menuButton {\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #0f63b2 0%, #0a4f96 100%);\n  box-shadow: 0 10px 24px rgba(0, 92, 188, 0.22);\n}\n\n.menuButton svg {\n  fill: #ffffff;\n}\n\n.workspaceBadge {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: linear-gradient(180deg, #0f63b2 0%, #0a4f96 100%);\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  padding: 8px;\n  box-shadow: 0 8px 18px rgba(0, 92, 188, 0.18);\n  flex-shrink: 0;\n}\n\n.workspaceDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #ffffff;\n  display: block;\n}\n\n.titleBlock {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n\n.titleExpanded {\n  font-size: 20px;\n  line-height: 1.2;\n  font-weight: 700;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.subtitle {\n  font-size: 12px;\n  line-height: 1.2;\n  font-weight: 500;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.headerMenuPanel {\n  top: 82px;\n  left: 28px;\n  width: 180px;\n  z-index: 1100;\n}\n\n.logoutButton {\n  width: 38px;\n  height: 38px;\n  min-width: unset !important;\n  border-radius: 50% !important;\n  padding: 0 !important;\n  background: #f4f7fb !important;\n  border: 1.5px solid #dbe4f0 !important;\n  box-shadow: none !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-shrink: 0;\n}\n\n.title {\n  font-size: 18px;\n  text-align: center;\n  font-weight: 700;\n  color: #272727;\n}\n\n.returnHomeBtn {\n  height: 28px !important;\n  border-radius: 4px !important;\n  border: 1px solid #d8e1ee !important;\n  background: #f8fbff !important;\n  color: #5a6f85 !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  padding: 2px 12px !important;\n  line-height: 1 !important;\n  box-shadow: none !important;\n}\n\n.returnHomeBtn:hover {\n  background: #eef5ff !important;\n  border-color: #c6d5ea !important;\n}\n\n.peplogo {\n  float: left;\n}\n\n.profile {\n  float: right;\n  float: right;\n  position: absolute;\n  right: 15px;\n  top: 21px;\n}\n\n/* Sidebar.css */\n.sidebar {\n  width: 50px;\n  height: 100vh;\n  background-color: rgb(242, 241, 241);\n  color: #111;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* padding-top: 20px; */\n  transition: width 0.3s;\n  z-index: 500;\n  position: fixed;\n  top: 50px;\n  box-shadow: var(--Elevation-X-Elevation-04, 4px)\n    var(--Elevation-Y-Elevation-04, 0px)\n    var(--Elevation-Blur-Elevation-04, 24px)\n    var(--Elevation-Spread-Elevation-04, -2px)\n    var(--Elevation-Colors-Elevation-04, rgba(0, 92, 188, 0.08));\n}\n\n.sidebar.expanded {\n  width: 150px;\n}\n\n.sidebarItem {\n  width: inherit;\n  padding: 10px 0px 10px 0px;\n  cursor: pointer;\n  display: flex;\n}\n\n.sidebarItem span {\n  padding-left: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.sidebarItem:hover {\n  background-color: #444343;\n}\n\n.sidebarItemActive {\n  border-left: 8px solid #005cbc;\n  margin-right: 5px;\n}\n\n@media screen and (max-width: 500px) {\n  /* .container{\n        padding: 15px 20px;\n        height: 60px\n    } */\n\n  .sidebar {\n    top: 0;\n    left: 0;\n  }\n\n  .title {\n    display: none;\n  }\n\n  .peplogo {\n    display: none;\n  }\n  .peplogoMobile {\n    margin-left: 0.5rem;\n  }\n\n  .pepSidebarMobile {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n  }\n\n  .secondHeader {\n    left: 0;\n    right: 0;\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .containerExpanded {\n    padding: 0 16px 0 16px;\n    height: 72px;\n  }\n\n  .titleExpanded {\n    font-size: 18px;\n  }\n\n  .subtitle {\n    font-size: 11px;\n  }\n\n  .headerMenuPanel {\n    left: 16px;\n    top: 64px;\n  }\n}\n\n@media screen and (min-width: 500px) {\n  .peplogoMobile {\n    display: none;\n  }\n\n  .pepSidebarMobile {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header_container__njogI`,
	"containerExpanded": `Header_containerExpanded__8IBR0`,
	"secondHeader": `Header_secondHeader__w30-x`,
	"secondHeaderLeft": `Header_secondHeaderLeft__5jSyd`,
	"secondHeaderRight": `Header_secondHeaderRight__hXAWw`,
	"expandedContainer": `Header_expandedContainer__EWRsS`,
	"expandedLeft": `Header_expandedLeft__-6D-N`,
	"expandedRight": `Header_expandedRight__WisRk`,
	"menuButton": `Header_menuButton__dRqbh`,
	"workspaceBadge": `Header_workspaceBadge__4YtBz`,
	"logoutButton": `Header_logoutButton__zD0wR`,
	"workspaceDot": `Header_workspaceDot__kvvCZ`,
	"titleBlock": `Header_titleBlock__BloBy`,
	"titleExpanded": `Header_titleExpanded__+LWsc`,
	"subtitle": `Header_subtitle__FApuL`,
	"headerMenuPanel": `Header_headerMenuPanel__UARLn`,
	"title": `Header_title__-5zqw`,
	"returnHomeBtn": `Header_returnHomeBtn__SZmka`,
	"peplogo": `Header_peplogo__NMKpU`,
	"profile": `Header_profile__7A7Jo`,
	"sidebar": `Header_sidebar__iiADr`,
	"expanded": `Header_expanded__5YrhI`,
	"sidebarItem": `Header_sidebarItem__YkKhK`,
	"sidebarItemActive": `Header_sidebarItemActive__RNxn5`,
	"peplogoMobile": `Header_peplogoMobile__5vqGE`,
	"pepSidebarMobile": `Header_pepSidebarMobile__Xl4M6`
};
export default ___CSS_LOADER_EXPORT___;
